"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaSendType = void 0;
/**
 * 验证码用途
 */
var CaptchaSendType;
(function (CaptchaSendType) {
    CaptchaSendType[CaptchaSendType["LOGIN"] = 0] = "LOGIN";
    CaptchaSendType[CaptchaSendType["SIGNUP"] = 1] = "SIGNUP";
    CaptchaSendType[CaptchaSendType["BIND_NEW"] = 2] = "BIND_NEW";
    CaptchaSendType[CaptchaSendType["REMOVE_ACCOUNT"] = 3] = "REMOVE_ACCOUNT";
    CaptchaSendType[CaptchaSendType["INVITE"] = 4] = "INVITE";
    CaptchaSendType[CaptchaSendType["AUTH"] = 5] = "AUTH";
    CaptchaSendType[CaptchaSendType["RESET_PASSWORD"] = 6] = "RESET_PASSWORD";
    CaptchaSendType[CaptchaSendType["CHANGE_BIND"] = 7] = "CHANGE_BIND";
})(CaptchaSendType = exports.CaptchaSendType || (exports.CaptchaSendType = {}));
